export default __webpack_public_path__ + "static/media/arrow_green_right.1955d866.svg";